import gql from 'graphql-tag';
import HelperGraphql from 'utils/helper-graphql'
import FieldsBookingInvitationLog from 'graphql/fields/FieldsBookingInvitationLog'

const fields = {
	'guid': 'String!',
}

export default gql(`
	query employee_booking_invitation( ${ HelperGraphql.createFields( fields ) } ) {
		employee_booking_invitation( guid: $guid ) {
			logs {
				${FieldsBookingInvitationLog}
			}
		}
	}
`);

